import styles from './LanguagesMenu.module.css';
import { IoIosArrowDown } from 'react-icons/io';

import Photo from '../../assets/images/Photo.png'; // Adjust the path as necessary

function LanguagesMenu() {
  return (
    <div className={styles.LanguagesMenu}>
      <img src={Photo} alt="Language Flag" />
      <p>Eng(US)</p>
      <IoIosArrowDown size={24} />
    </div>
  );
}

export default LanguagesMenu;
